<template>
	<div>
		<v-dialog v-model="color_picker_dialog" no-click-animation persistent scrollable content-class="select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	
	        	<sketch-picker v-model="colors"></sketch-picker>

		        <!-- <v-divider></v-divider> -->
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
          			<v-btn small color="blue darken-1" flat @click="updateColor">ok</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
import {Sketch} from 'vue-color'

let defaultProps = {
  hex: '#194d33e6',
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 0.9
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.30,
    a: 0.9
  },
  rgba: {
    r: 159,
    g: 96,
    b: 43,
    a: 0.9
  },
  a: 0.9
}
	export default{
		data(){
			return{
				color_picker_dialog:false,
				colors:"#ffffff"
			}
		},
		components:{
			'sketch-picker':Sketch
		},
		methods:{
			openDialogWeb: function () {
				if(this.$parent.Form.colorPickerType == 'theme'){
					this.colors = this.$parent.Form.themeColor;	
				}
				else{
					this.colors = this.$parent.Form.tableRowColor;		
				}
				
				this.color_picker_dialog = true;
			},
			closeDialogWeb: function () {
				this.color_picker_dialog = false;
			},
			updateColor: function(){
				console.log(this.$parent.Form.themeColor);
				if(typeof(this.colors) == 'object' ){
					if(this.$parent.Form.colorPickerType == 'theme'){
						this.$parent.Form.themeColor = this.colors.hex;	
					}
					else{
						this.$parent.Form.tableRowColor = this.colors.hex;
					}
				}
				else{
					if(this.$parent.Form.colorPickerType == 'theme'){
						this.$parent.Form.themeColor = this.colors.hex;	
					}
					else{
						this.$parent.Form.tableRowColor = this.colors.hex;
					}
				}
				// this.color_picker_dialog = false;
				this.$parent.fn_closeDialog();
				console.log(this.colors);
			}
		}
	}
</script>

<style>
	.vc-sketch{
		width:auto !important;
		box-shadow:none !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/print_templates/dialogs/dialog_color_picker.vue